import angular from 'angular';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalExperience from './modal-experience/modal-experience.view.html';
import ModalExperienceController from "./modal-experience/modal-experience.controller";
import modalConfirmationMora from './modal-confirmation-mora/modal-confirmation-mora.view.html';

let inject = [
    '$scope',
    'ConfirmationOrderService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$timeout',
    '$stateParams',
    '$window',
    'ngAuthSettings'
];

class ConfirmationOrderController {
    constructor($scope, ConfirmationOrderService, $state, $rootScope, SharedService, $uibModal, $timeout, $stateParams, $window, ngAuthSettings) {
        this.$state = $state;
        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$uibModal = $uibModal;
        this.ConfirmationOrderService = ConfirmationOrderService;
        this.SharedService = SharedService;
        this.orderId = this.$stateParams.orderId;
        this.loadingDataOrder = true;
        this.orderData = {};
        this.resolving = this.$stateParams.resolve === 'true';
        this.alreadySend = false;
        this.loadingStatusDebtsToPay = false;
        this.ngAuthSettings = ngAuthSettings;


        this.showBottomInfo = __env.clientName === 'laskin';

    }

    $onInit() {
        this.getOrder();
    }

    getOrder() {
        this.loadingDataOrder = true;
        let userId = '', sellerId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {

        }

        try {
            sellerId = this.shCtrl.globals.currentUser.sellerId;
        }
        catch (e) {
        }
        this.ConfirmationOrderService.getOrderById(userId, sellerId, this.orderId).then(response => {

            if (!response.error) {
                this.orderData = response.data.order;
                this.orderData.totalPesoItems = 0;
                this.orderData.cantidadTotalCanasta = 0;

                // this.orderData.experience_comment

                response.data.order.items.forEach(val => {
                    this.orderData.totalPesoItems += val.cantidad * val.peso_embalaje;
                    this.orderData.cantidadTotalCanasta += val.cantidad;
                });

            } else {

                alert('Ha ocurrido un error al obtener los datos');
            }
             this.loadingDataOrder = false;
        })
    }

    payNow() {
        let thirdId = this.shCtrl.userData.globals.currentUser.thirdId;
        let sucursalCodigo = this.shCtrl.globals.currentClient.operatingCenter.code;
        let validaMora = this.ngAuthSettings.site.info.company.validaMoraPagoPedidos;
        let data = {
            'thirdId' : thirdId,
            'sucursalCodigo' : sucursalCodigo 
        };
        if(validaMora){
            this.loadingStatusDebtsToPay = true;
        }
        this.ConfirmationOrderService.checkDefaultPaymentOrders(data).then(response => {
            this.loadingStatusDebtsToPay = false;
            if(!response.error){
                if(response.data.verificaMora){
                    if(response.data.mora){
                          this.showModalMora();
                    } else{
                        this.$window.location = window.__env.envApiServiceBaseUri + '/order/pay-gate?id=' + this.orderData.id;
                    }
                } else{
                    this.$window.location = window.__env.envApiServiceBaseUri + '/order/pay-gate?id=' + this.orderData.id;
                }
            }
        });
    }

    openExperienceModal() {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalExperience,
            controller: 'ModalExperienceController',
            controllerAs: 'mdCtrl',
            resolve: {
                orderData: () => this.orderData
            }
        });
        modalInstance.result.then((value) => {

            if(!value.error){
                this.alreadySend = true;
                this.orderData["experience_comment"]= value.data.experience_comment;
                this.orderData["experience_rating"]= value.data.experience_rating;
            }

            let options = {
                title: '',
                isHtml: false,
                content: value.message,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);
        }).catch(reason => {
            console.log(reason);
        });
    }


    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    showModalMora() {
        let options = this.shCtrl;
        let modal_options = this.$uibModal.open({
          animation: true,
          template: modalConfirmationMora,
          controller: 'ModalConfirmationMoraController',
          controllerAs: 'mdCtrl',
          backdrop: 'static',
          keyboard: false,
          size: 'lg',
          resolve: {
            modalOptions: () => options
          }
        });
        modal_options.result.then(() => {
          
        }).catch(reason => {
    
        });
      }
}

ConfirmationOrderController.$inject = inject;

export default ConfirmationOrderController;




/** WEBPACK FOOTER **
 ** ./www/components/confirmation-order/confirmation-order.controller.js
 **/